import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInputClass;
function GrantDiscordAccessInput() {
  if (GrantDiscordAccessInputClass === VOID) {
    class $ {
      constructor(code, partyId, guildId) {
        this.b6o_1 = code;
        this.c6o_1 = partyId;
        this.d6o_1 = guildId;
      }
      toString() {
        return 'GrantDiscordAccessInput(code=' + this.b6o_1 + ', partyId=' + this.c6o_1.toString() + ', guildId=' + this.d6o_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.b6o_1);
        result = imul(result, 31) + this.c6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessInput()))
          return false;
        if (!(this.b6o_1 === other.b6o_1))
          return false;
        if (!this.c6o_1.equals(other.c6o_1))
          return false;
        if (!(this.d6o_1 === other.d6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessInput');
    GrantDiscordAccessInputClass = $;
  }
  return GrantDiscordAccessInputClass;
}
//region block: exports
export {
  GrantDiscordAccessInput as GrantDiscordAccessInputqu7hxtlblgwv,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput.mjs.map
